import { render, staticRenderFns } from "./workFlowRoleManage.vue?vue&type=template&id=22f41735&scoped=true&"
import script from "./workFlowRoleManage.vue?vue&type=script&lang=js&"
export * from "./workFlowRoleManage.vue?vue&type=script&lang=js&"
import style0 from "./workFlowRoleManage.vue?vue&type=style&index=0&id=22f41735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f41735",
  null
  
)

export default component.exports